import { observable } from "mobx";
import KioskDisplayStatus from "./kioskDisplayStatus";
import KioskPurchaseStatus from "./kioskPurchaseStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class KioskResponse {
  id!: string;

  @observable
  kioskIdent!: number;

  @observable
  name!: string;

  @observable
  alias!: string;

  @observable
  displayStatus!: KioskDisplayStatus;

  @observable
  purchaseStatus!: KioskPurchaseStatus;

  @observable
  terminalId?: string;

  @observable
  locationName?: string;

  @observable
  locationDetail?: string;
}
